import { menuItems } from '@/core/constants/new-menu-items.constant'
import sharedEnglishMessages from '@/shared/lang/en.json'

const moduleEnglishMessages = import.meta.glob('@/modules/**/i18n/en.json', {
  eager: true,
})

function deepMerge(target, source) {
  Object.entries(source).forEach(([key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (!target[key] || typeof target[key] !== 'object')
        target[key] = {}
      deepMerge(target[key], value)
      return
    }
    target[key] = value
  })

  return target
}

let englishMessages = null

function getEnglishMessages() {
  if (!englishMessages) {
    englishMessages = deepMerge({}, sharedEnglishMessages)
    Object.values(moduleEnglishMessages).forEach((messagesFile) => {
      deepMerge(englishMessages, messagesFile.default || messagesFile)
    })
  }

  return englishMessages
}

function collectMenuEntries(items, inheritedModule, accumulator) {
  if (!Array.isArray(items))
    return accumulator

  items.forEach((item) => {
    const itemModule = item?.module || inheritedModule || null

    if (item?.route && item?.name)
      accumulator.push({ route: item.route, titleKey: item.name, module: itemModule })

    collectMenuEntries(item?.children, itemModule, accumulator)
  })

  return accumulator
}

function buildMenuEntries() {
  return Object.values(menuItems || {})
    .reduce((all, group) => collectMenuEntries(group, null, all), [])
    .sort((first, second) => second.route.length - first.route.length)
}

let menuEntries = null

function getMenuEntries() {
  if (!menuEntries)
    menuEntries = buildMenuEntries()

  return menuEntries
}

function coversPath(routePath, menuRoute) {
  if (menuRoute === '/')
    return routePath === '/'

  return routePath === menuRoute || routePath.startsWith(`${menuRoute}/`)
}

export function resolveMenuEntry(routePath) {
  if (!routePath)
    return null

  return getMenuEntries().find(entry => coversPath(routePath, entry.route)) || null
}

export function translateMenuTitle(titleKey) {
  if (typeof titleKey !== 'string' || !titleKey)
    return null

  const title = titleKey
    .split('.')
    .reduce((node, part) => (node == null ? node : node[part]), getEnglishMessages())

  return typeof title === 'string' && title.trim() !== '' ? title : null
}

export function resolvePageContext(route) {
  const routePath = route?.path || ''
  const menuEntry = resolveMenuEntry(routePath)

  return {
    module: route?.meta?.module || menuEntry?.module || routePath.split('/').find(Boolean) || null,
    title: translateMenuTitle(menuEntry?.titleKey)
      || translateMenuTitle(route?.meta?.breadcrumb?.label)
      || translateMenuTitle(route?.name),
  }
}
